export default "__VITE_ASSET__Bfze0SAf__"